export default class KontingentperiodeDto {

  constructor(json) {
    if (json) {
      this.json = json

      this.id = json.id;
      this.start = new Date(json.start)
      this.ende = new Date(json.ende)
      this.storniert = !!json.storniert
      this.briefversandPflicht = !!json.briefversandPflicht
    } else {
      this.json = {}
    }
  }
}
